module.exports = __webpack_public_path__ + "static/logo2-74519ad20672c916a0d1a48656393417.png";